/**
 * Avatar.jsx — Discord-avatar component with monogram fallback (#143).
 *
 * Renders a small round avatar from a cached Discord CDN URL. When no
 * URL is supplied (anonymous user, hide_avatar opt-out, no linked
 * Discord) it falls back to the first character of the supplied label.
 */
import { Show, createSignal } from 'solid-js';
import './Avatar.css';

function withSize(url, size) {
  if (!url) return url;
  if (url.includes('?')) return url;
  return `${url}?size=${size || 48}`;
}

export default function Avatar(props) {
  const [errored, setErrored] = createSignal(false);
  const size = () => props.size || 24;
  const url  = () => (errored() ? null : props.url);
  const mono = () => {
    const n = String(props.name || '?').trim();
    return n ? n.replace(/^@/, '').slice(0, 1).toUpperCase() : '?';
  };

  return (
    <span
      class={'v2-avatar' + (props.class ? ' ' + props.class : '')}
      style={{
        width:  `${size()}px`,
        height: `${size()}px`,
        'font-size': `${Math.max(10, Math.floor(size() * 0.42))}px`,
      }}
      aria-label={props.name ? `${props.name} avatar` : 'avatar'}
    >
      <Show when={url()} fallback={<span class="v2-avatar__mono">{mono()}</span>}>
        <img
          src={withSize(url(), size() * 2)}
          alt=""
          loading="lazy"
          onError={() => setErrored(true)}
        />
      </Show>
    </span>
  );
}
